import './TestIframe.scss';
import { Loader } from '@trackman/web-shared-components';
import { useEffect, useRef } from 'react';
import { LessonParams } from 'types/lessons';

type TestIframeProps = {
  area9LaunchUrl: string;
  lessonParams: LessonParams[];
};

export const TestIframe = ({ area9LaunchUrl, lessonParams }: TestIframeProps) => {
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
      if (lessonParams.length > 0 && formRef.current) formRef.current.submit();
    }, [lessonParams, formRef]);

  return (
    <div className='iframe-container'>
      {area9LaunchUrl && lessonParams.length > 0 ? (
        <>
          <form ref={formRef} method='post' encType='application/x-www-form-urlencoded' target='a9frame' action={area9LaunchUrl}>
            {lessonParams.map((param) => (
              <input type='hidden' name={param.name} value={param.value} key={param.name} />
            ))}
          </form>
          <iframe title='a9frame' name='a9frame' id='a9frame' src='about:blank' />
        </>
      ) : (
        <div className='loader-wrapper'>
          <Loader size='large' />
        </div>
      )}
    </div>
  );
};
